/* eslint-disable no-nested-ternary */
import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`
export const Div = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 12px;
  color: ${colors.grey900};
  gap: 5px;
`
export const ChevronRightStyle = styled.button`
  border: none;
  background-color: ${colors.surface};
  margin-left: 5px;
  cursor: pointer;
`
export const DivSeparate = styled.div`
  margin-top: 5px;
`
export const Span = styled.span`
  display: flex;
  align-items: flex-start;
`
export const DivIcon = styled.div`
  background-color: ${colors.azul1};
  width: 56px;
  height: 56px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  margin-right: 15px;
`

export const Td = styled.div<{ classification: string }>`
  color: ${({ classification }) =>
    classification === 'EM_ALTA'
      ? `${colors.secondaryText}`
      : classification === 'EM_BAIXA'
      ? `${colors.errorText}`
      : `${colors.system}`};
  padding: 5px 0px 10px 0px;
  border-radius: 9px;
  text-transform: capitalize;
  display: flex;
  align-items: center;

  span {
    font-size: 6px;
    margin-right: 5px;
    margin-top: 2px;
  }
`
